import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-gift-or-travel-form',
    templateUrl: './gift-or-travel-form.component.html',
})
export class GiftOrTravelFormComponent {
    @Input({ required: true }) form!: FormGroup;
}
